import { setAxiosErrorCallback } from '@hooks/useAxiosInterceptor';
import { useEffect, useState } from 'react';

interface Error {
    message: string;
    url?: string;
    method?: string;
    status?: number;
}

const NetworkErrorDisplay = () => {
    const [errors, setErrors] = useState<Error[]>([]);

    useEffect(() => {
        setAxiosErrorCallback((error) => {
            const errData = {
                message: error.message,
                url: error.config?.url,
                method: error.config?.method,
                status: error.response?.status,
            };

            setErrors((prev) => [errData, ...prev]);
        });

        return () => setAxiosErrorCallback(null);
    }, []);

    if (errors.length === 0) return null;

    return (
        <div className="block w-full box-border p-4 bg-red-100 border border-red-400 rounded text-sm text-black max-h-[200px] overflow-y-auto">
            <div className="grid grid-cols-1">
                {errors.map((err, index: number) => (
                    <div className="list-none break-all" key={index}>
                        <strong>
                            - {err.method?.toUpperCase()} {err.status} {err.url}
                        </strong>{' '}
                        - {err.message}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default NetworkErrorDisplay;
